// @flow

import React, {Component} from 'react'
import css from './MedicineGuideItem.css'
import MedicineGuideItemText from './MedicineGuideItemText'

type State = {
  isOpen: boolean | null,
}

type Props = {
  title: string,
  text: string
}

class MedicineGuide extends Component {
  props: Props

  state: State = {
    isOpen: null,
  }

  toggleText = () => {
    this.setState({isOpen: !this.state.isOpen})
  }

  render() {
    const {isOpen} = this.state
    const {title, text} = this.props

    return (
      <div className={css.component}>
        <h5
          className={isOpen ? css.elementOpen : css.element}
          onClick={this.toggleText}
        >
          {title}
        </h5>
        {isOpen !== null &&  <MedicineGuideItemText text={text} mounted={this.state.isOpen}/>}
      </div>
    )
  }
}

export default MedicineGuide



// WEBPACK FOOTER //
// ./src/homepage/components/MedicineGuideItem.js